var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.386,
    height: 16.386,
    viewBox: "0 0 16.386 16.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9209",
    "data-name": "Group 9209",
    transform: "translate(0 1.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9208",
    "data-name": "Group 9208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58562",
    "data-name": "Path 58562",
    d: "M13.46,41.159a.585.585,0,0,0-.585.585V47.6a.585.585,0,0,1-.585.585H1.756A.585.585,0,0,1,1.17,47.6v-11.7a.585.585,0,0,1,.585-.585H8.778a.585.585,0,1,0,0-1.17H1.756A1.756,1.756,0,0,0,0,35.893V47.6a1.756,1.756,0,0,0,1.756,1.756H12.289A1.756,1.756,0,0,0,14.045,47.6V41.745A.585.585,0,0,0,13.46,41.159Z",
    transform: "translate(0 -34.137)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9211",
    "data-name": "Group 9211",
    transform: "translate(3.511 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9210",
    "data-name": "Group 9210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58563",
    "data-name": "Path 58563",
    d: "M114.627.66a2.24,2.24,0,0,0-3.169,0L103.75,8.368a.592.592,0,0,0-.141.229l-1.17,3.511a.585.585,0,0,0,.555.77.594.594,0,0,0,.185-.03l3.511-1.17a.585.585,0,0,0,.229-.142l7.708-7.708A2.24,2.24,0,0,0,114.627.66ZM113.8,3l-7.608,7.608-2.273.759.757-2.27,7.611-7.608A1.069,1.069,0,1,1,113.8,3Z",
    transform: "translate(-102.409 -0.004)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dc310c91a8a26a141f2554aca7816841.svg";
export { ForwardRef as ReactComponent };